<template>
  <div class="users__filters-inputs">
    <e-input v-model="dialogValue.searchString" label="Поиск" class="users__filters-search">
      <template #append-inner>
        <e-icon name="search" :size="20" />
      </template>
    </e-input>
    <template v-if="$vuetify.display.lgAndUp">
      <e-select v-model="dialogValue.filterRole" item-value="value" label="Роль" clearable :items="roleFilterItems" />
    </template>

    <filters-dialog v-else v-model="dialogValue" :default-filters="defaultFilters">
      <template #activator>
        <e-btn icon variant="tonal">
          <e-icon name="options" />
        </e-btn>
      </template>

      <template #default="{ items }">
        <div>
          <e-input v-model="items.searchString" label="Поиск" class="mb-4">
            <template #append-inner>
              <e-icon name="search" :size="20" />
            </template>
          </e-input>
          <e-select
            v-model="items.filterRole"
            item-value="value"
            label="Роль"
            clearable
            :items="roleFilterItems"
            class="mb-4"
          />
        </div>
      </template>
    </filters-dialog>
  </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import FiltersDialog from '@/core/components/common/FiltersDialog.vue';
import { EBtn, EIcon, EInput, ESelect } from '@/core/components/ui';
import { defaultFilters, type RolesType, type UsersFilters } from '@/parts/users/utils/consts';

const props = defineProps<{
  modelValue: UsersFilters;
  roleFilterItems: {
    title: string;
    value: RolesType;
  }[];
}>();

const dialogValue = useVModel(props, 'modelValue');
</script>

<style scoped lang="scss">
.users {
  &__filters {
    &-inputs {
      display: grid;
      align-items: center;

      grid-gap: $gap-4;
      grid-template-columns: 1fr 1fr;

      width: 40%;

      @include lg-and-down {
        width: 60%;
        margin-right: $gap-4;
      }

      @include sm-and-down {
        display: flex;

        margin-right: 0;
      }
    }

    &-search {
      @include md-and-down {
        min-width: 240px;
      }
      @include sm-and-down {
        width: 100%;
        min-width: initial;
      }
    }
  }
}
</style>
